import styled from 'vue-styled-components';

export const Wrapper = styled.div`
  width: 100%;
  margin-top: 2rem;
`;

export const ContentList = styled.div`
  display: grid;
  gap: 1rem;

  .pagination {
    justify-self: end;
  }
`;
